module.exports = __webpack_public_path__ + "static/media/sierra-leone-gov.0f3959c7.png";